import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { Map } from 'immutable'
import * as ROUTE from 'constants/appRouting'
import Jobs from './Jobs'
import Tasks from './Tasks'
import InputItems from './InputItems'
import Inputs from './Inputs'
import InputGroups from './InputGroups'
import JobsWorkflowAdminLayout from './JobsWorkflowAdminLayout'

const items = {
  data: [
    {
      path: ROUTE.JOB_WORKFLOWS,
      alt: 'Job Workflows',
      name: 'job',
    },
    {
      path: ROUTE.JOB_WORKFLOW_TASKS,
      alt: 'Job Workflow Tasks',
      name: 'job_task',
    },
    {
      path: ROUTE.JOB_WORKFLOW_INPUT_ITEMS,
      alt: 'Job Workflow Input Items',
      name: 'job_input',
    },
  ],
  count: 3,
}

function JobsWorkflowAdmin(props) {
  return (
    <Switch>
      <Route path={ROUTE.JOB_WORKFLOWS_JOB_EDIT_PATTERN} component={Jobs} />
      <Route path={ROUTE.JOB_WORKFLOW_TASKS_EDIT_PATTERN} component={Tasks} />
      <Route path={ROUTE.JOB_WORKFLOW_INPUTS_EDIT_PATTERN} component={Inputs} />
      <Route
        path={ROUTE.JOB_WORKFLOW_INPUT_GROUPS_EDIT_PATTERN}
        component={InputGroups}
      />
      <Route
        path={ROUTE.JOB_WORKFLOW_INPUT_ITEMS_EDIT_PATTERN}
        component={InputItems}
      />
      <Route
        path={ROUTE.JOBS_WORKFLOW_ADMIN}
        component={() => (
          <JobsWorkflowAdminLayout tableData={new Map(items)} {...props} />
        )}
      />
    </Switch>
  )
}

export default withRouter(JobsWorkflowAdmin)
